import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'sw-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @Input() title: string = 'Modal Title';
  @Input() position = 'center';
  @Output() confirmed = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  closeModal(event?: MouseEvent) {
    this.closed.emit();
  }

  confirm() {
    this.confirmed.emit();
  }

  @HostListener('document:keydown.escape') onKeydownHandler() {
    this.closeModal();
  }
}
